import {
    AUTH_LOGOUT,
    AUTH_LOGOUT_FAILURE,
    AUTH_LOGOUT_SUCCESS,
} from 'store/actions/types';

export const authLogout = (payload) => {
    return {
        type: AUTH_LOGOUT,
        payload: payload,
    };
};

export const authLogoutFailure = (error) => {
    return {
        type: AUTH_LOGOUT_FAILURE,
        error: error,
    };
};

export const authLogoutSuccess = () => {
    return {
        type: AUTH_LOGOUT_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth/authLogout.js